import React from "react";
import Skeleton from "react-loading-skeleton";

const ProductInfoGallerySkeleton: React.FC = () => {
  return (
    <div className="product-info-gallery">
      <Skeleton style={{ aspectRatio: "3/4", height: "auto", width: "100%" }} />
    </div>
  );
};

export default ProductInfoGallerySkeleton;
